import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-doc-icons',
  templateUrl: './doc-icons.component.html',
  styleUrls: ['./doc-icons.component.scss']
})
export class DocIconsComponent implements OnInit {

  constructor() { }
  @Input() iconType = ''
  
  ngOnInit(): void {
  }

}
